import styled from 'styled-components';
import { cssVars } from '../../../shared/lib/styledTheme';
import { Select as BaseSelect } from '../../../shared/ui/Select';

export const TicketListContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: ${cssVars.bgSecondary};
  border-right: 1px solid ${cssVars.borderColor};
`;

export const TicketListHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid ${cssVars.borderColor};
  background-color: ${cssVars.bgSecondary};
`;

export const CreateTicketButton = styled.button`
  width: 100%;
  padding: 14px 18px;
  background: linear-gradient(135deg, ${cssVars.primary} 0%, ${cssVars.primaryHover} 100%);
  color: ${cssVars.white};
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const FiltersContainer = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid ${cssVars.borderColor};
  background-color: ${cssVars.bgSecondary};
`;

export const FilterCheckbox = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  cursor: pointer;
  font-size: 14px;
  color: ${cssVars.textPrimary};

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;

export const SiteFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  margin-top: 8px;
  border-top: 1px solid ${cssVars.borderLight};
`;

export const SiteFilterLabel = styled.label`
  font-size: 14px;
  color: ${cssVars.textPrimary};
  white-space: nowrap;
`;

export const SiteFilterSelect = styled(BaseSelect)`
  flex: 1;
  font-size: 13px;
  padding: 8px 12px;
  padding-right: 36px;
`;

export const TicketsSection = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
`;

export const TicketsSectionTitle = styled.div`
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${cssVars.textSecondary};
  letter-spacing: 0.5px;
`;

export const LoadingState = styled.div`
  padding: 16px;
  color: ${cssVars.textSecondary};
`;

export const TicketItem = styled.div<{ $active?: boolean; $hasUnread?: boolean }>`
  padding: 16px 20px;
  cursor: pointer;
  border-left: 4px solid transparent;
  background-color: ${props => props.$active ? cssVars.selected : 'transparent'};
  border-left-color: ${props => props.$active ? cssVars.primary : 'transparent'};
  transition: all 0.2s;
  margin: 2px 0;

  &:hover {
    background-color: ${props => props.$active ? cssVars.selected : cssVars.hover};
    border-left-color: ${props => props.$active ? cssVars.primary : cssVars.borderColor};
  }
`;

export const TicketItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
`;

export const TicketItemTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${cssVars.textPrimary};
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
`;

export const TicketItemTitleText = styled.span`
  flex: 1;
  min-width: 0;
`;

export const TicketSiteBadge = styled.span<{ $site: string }>`
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background-color: ${props => props.$site === 'hudle' ? '#4CAF50' : props.$site === 'unknown' ? '#9E9E9E' : '#2196F3'};
  color: ${cssVars.white};
  white-space: nowrap;
  align-self: flex-start;
  margin-top: 1px;
`;

export const UnreadIndicator = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${cssVars.primary};
  flex-shrink: 0;
`;

export const TicketItemPreview = styled.div`
  font-size: 13px;
  color: ${cssVars.textSecondary};
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

